import React from 'react';
import BaseIcon from './BaseIcon';

class HomeSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        width={width}
        height={height}
        viewBox="0 0 59.812 59.875"
      >
        <path
          d="M59.47 33.655a.995.995 0 01-1.407-.069l-4.244-4.693v28.986a1.996 1.996 0 01-1.992 1.997H40.866c-1.099 0-1.96-.9-1.96-2.001v-19h-18v19c0 1.101-.861 2.001-1.96 2.001H7.986a1.997 1.997 0 01-1.993-1.997V28.892l-4.245 4.694a.994.994 0 01-1.407.069 1 1 0 01-.07-1.41L29.168.291c.378-.418 1.098-.418 1.477 0L59.54 32.245a1 1 0 01-.07 1.41zM29.906 2.449L7.899 26.784c.002.03.007.063.007.091v31l11.04.004V38.907c0-1.102.894-1.998 1.993-1.998h17.935c1.099 0 1.992.896 1.992 1.998v18.972l11.04-.004V26.777l-22-24.328z"
          fill={fillColor}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}

export default HomeSVG;
